module.exports = __webpack_public_path__ + "img/symbol_4.acb01724.png";